import React from 'react';

import { Card, Button, Stack, Center } from '@mantine/core';

import type { WithTestId } from 'types/common';

type ErrorCardProps = {
  button?: React.ReactNode;
  customStyles?: React.CSSProperties;
  children: React.ReactNode;
} & WithTestId;

export default function ErrorCard({
  button,
  customStyles,
  children,
  'data-testid': testId,
}: ErrorCardProps) {
  return (
    <Card
      data-testid={testId}
      style={{
        padding: 'var(--mantine-spacing-xl)',
        justifyContent: 'center',
        ...(customStyles && { ...customStyles }),
      }}
    >
      <Center>
        <Stack>
          {children}
          <Center>
            {button || (
              <Button onClick={() => window.location.reload()} size="sm" variant="outline">
                Refresh
              </Button>
            )}
          </Center>
        </Stack>
      </Center>
    </Card>
  );
}
